import React from "react";
import "./LeaveRequestStats.scss";

const STAT_ITEMS = [
  { key: "total", label: "Total requests", modifier: "total" },
  { key: "approved", label: "Approved", modifier: "approved" },
  { key: "rejected", label: "Rejected", modifier: "rejected" },
  { key: "cancelled", label: "Cancelled", modifier: "cancelled" },
];

const LeaveRequestStats = ({ statusCounts, loading = false }) => {
  const counts = statusCounts || {};

  return (
    <section className="leave-request-stats" aria-label="Leave request statistics">
      <div className="leave-request-stats__grid">
        {STAT_ITEMS.map(({ key, label, modifier }) => (
          <div
            key={key}
            className={`leave-request-stats__card leave-request-stats__card--${modifier} card-border card-body`}
          >
            <div className="leave-request-stats__label">{label}</div>
            <div className="leave-request-stats__value">
              {loading ? "…" : counts[key] ?? 0}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default LeaveRequestStats;
